// Functional utility that determines a key based on an event object
const isKey = value => ({
  key
}) => key && key === value;

// Handy functions when dealing with A11y
const isEscape = isKey("Escape");
const isEnter = isKey("Enter");
const isShift = ({
  shiftKey
}) => shiftKey;
const isTab = e => !isShift(e) && isKey("Tab")(e);
const isShiftTab = e => isShift(e) && isKey("Tab")(e);
const isArrowUp = isKey("ArrowUp");
const isArrowDown = isKey("ArrowDown");
const isArrowLeft = isKey("ArrowLeft");
const isArrowRight = isKey("ArrowRight");

export { isKey as default, isArrowDown, isArrowLeft, isArrowRight, isArrowUp, isEnter, isEscape, isShift, isShiftTab, isTab };
